import apiV2 from "@/apiConfig/api-v2";

export default {
  namespaced: true,
  state() {
    return {
      transactions: [],
      monthlyPayment: null,
      realBalance: null,
      monthlyPayments: [], // Multi-group: array of payments (one per group)
    };
  },
  mutations: {
    SET_TRANSACTIONS(state, transactions) {
      state.transactions = transactions;
    },
    SET_MONTHLY_PAYMENT(state, payment) {
      state.monthlyPayment = payment;
    },
    SET_REAL_BALANCE(state, balance) {
      state.realBalance = balance;
    },
    SET_MONTHLY_PAYMENTS(state, payments) {
      state.monthlyPayments = payments;
    },
  },
  actions: {
    async getTransactions({ commit }, { student_id }) {
      try {
        const res = await apiV2.get(`/payments/transactions/${student_id}`, {
          params: { student_id },
        });

        commit("SET_TRANSACTIONS", res.data || []);
      } catch (error) {
        commit("SET_TRANSACTIONS", []);
      }
    },
    async createTransaction({ dispatch }, transactionData) {
      try {
        await apiV2.post("/payments/transactions", transactionData);
        dispatch("getTransactions", {
          student_id: transactionData.student_id,
          page: 1,
        });
      } catch (error) {
        console.error("Error creating transaction:", error);
      }
    },
    async getMonthlyPayment({ commit }, { student_id, year, month }) {
      try {
        const res = await apiV2.get(
          `/payments/monthly-payments/${student_id}`,
          {
            params: { student_id, year, month },
          }
        );
        // Multi-group support: API now returns array
        const data = res.data;
        if (Array.isArray(data)) {
          commit("SET_MONTHLY_PAYMENTS", data);
          // Keep backward compat: monthlyPayment = first item
          commit("SET_MONTHLY_PAYMENT", data.length > 0 ? data[0] : null);
        } else {
          // Old format (single object) — wrap in array
          commit("SET_MONTHLY_PAYMENT", data || null);
          commit("SET_MONTHLY_PAYMENTS", data ? [data] : []);
        }
      } catch (error) {
        commit("SET_MONTHLY_PAYMENT", null);
        commit("SET_MONTHLY_PAYMENTS", []);
      }
    },
  },
  getters: {
    transactions: (state) => state.transactions,
    monthlyPayment: (state) => state.monthlyPayment,
    realBalance: (state) => state.realBalance,
    monthlyPayments: (state) => state.monthlyPayments,
  },
};
